import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as UserSelectors from 'app/modules/user/selectors'
import * as UserPropertiesSelectors from 'app/modules/user/properties/selectors'
import * as OrgSelectors from 'app/modules/org/selectors'
import * as ProfileSelectors from 'app/modules/profile/selectors'
import * as UserActions from 'app/modules/user/actions'
import * as UserPropertiesActions from 'app/modules/user/properties/actions'
import * as EmbedSelectors from 'app/modules/embed/selectors'
import DriftAgentFlyout from './Popover'
import AgentStatusAvatar from './AgentStatusAvatar'
import { AvailabilityStatus, NotificationSnoozeStatus, getStatusIcon } from './constants'
import values from 'ramda/src/values'
import contains from 'ramda/src/contains'

import './style.styl'

class NewAgentStatus extends Component {
  constructor(props) {
    super(props)

    this.state = {
      flyoutOpen: false,
    }

    this.onClickOutside = this.toggleOpen
  }

  toggleOpen = () => {
    this.setState(prevState => {
      return {
        flyoutOpen: !prevState.flyoutOpen,
      }
    })
  }

  resolveNotificationSnoozeStatus = () => {
    const notificationsSnoozed = this.props.settings.get('notifications-snoozed')
    return !!notificationsSnoozed ? NotificationSnoozeStatus.ON : NotificationSnoozeStatus.OFF
  }

  renderFlyOut() {
    const { flyoutOpen } = this.state
    const {
      currentUser,
      globalHandle,
      actions,
      settings,
      defaultInboxId,
      isUserAtConversationLimit,
      orgProperties: { limitNumChats, limitNumChatsEnabled },
      hasDriftHelpCutover,
      trafficControlConfig
    } = this.props

    if (!flyoutOpen) return null

    const autoAway = settings && settings.get('auto-away')

    return (
      <DriftAgentFlyout
        user={currentUser}
        isActive={this.isActive()}
        onClickOutside={this.toggleOpen}
        notificationSnoozeStatus={this.resolveNotificationSnoozeStatus()}
        globalHandle={globalHandle}
        updateCurrentUser={actions.updateCurrentUser}
        updateUserProperties={actions.updateUserProperties}
        turnOffManualAway={actions.turnOffManualAway}
        limitNumChats={limitNumChats}
        limitNumChatsEnabled={limitNumChatsEnabled}
        atConversationLimit={isUserAtConversationLimit}
        autoAway={autoAway}
        defaultInboxId={defaultInboxId}
        hasDriftHelpCutover={hasDriftHelpCutover}
        trafficControlConfig={trafficControlConfig}
      />
    )
  }

  isActive = () => {
    const { currentUser } = this.props
    return (
      currentUser.availability === AvailabilityStatus.ACTIVE ||
      currentUser.availability === AvailabilityStatus.ON_CALL
    )
  }

  resolveStatusIcon = () => {
    const {
      currentUser,
      orgProperties,
      isUserAtConversationLimit } = this.props
    const isValidAgentStatus = contains(currentUser.availability, values(AvailabilityStatus))
    const agentAvailability = isValidAgentStatus ? currentUser.availability : AvailabilityStatus.AWAY
    const notificationSnoozeStatus = this.resolveNotificationSnoozeStatus()
    const limitNumChatsEnabled = orgProperties && orgProperties.limitNumChatsEnabled

    return getStatusIcon(agentAvailability, notificationSnoozeStatus, limitNumChatsEnabled && isUserAtConversationLimit)
  }

  render() {
    const { currentUserLoaded } = this.props
    if (!currentUserLoaded) return null

    return (
      <div className="new-agent-status with-new-status-avatar">
        <AgentStatusAvatar onClick={this.toggleOpen} />
        {this.renderFlyOut()}
      </div>
    )
  }
}

const makeMapStateToProps = () => {
  return state => ({
    currentUser: UserSelectors.currentUser(state),
    currentUserLoaded: UserSelectors.currentUserLoaded(state),
    settings: UserPropertiesSelectors.properties(state),
    orgProperties: OrgSelectors.properties(state),
    globalHandle: ProfileSelectors.globalHandle(state),
    defaultInboxId: EmbedSelectors.defaultInboxId(state),
    isUserAtConversationLimit: UserPropertiesSelectors.isUserAtConversationLimit(state),
    trafficControlConfig: UserSelectors.trafficControlConfig(state),
  })
}

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(
    {
      updateCurrentUser: UserActions.updateCurrentUser,
      turnOffManualAway: UserActions.turnOffManualAway,
      updateUserProperties: UserPropertiesActions.updateUserProperties,
    },
    dispatch
  ),
})

export default connect(makeMapStateToProps, mapDispatchToProps)(NewAgentStatus)



// WEBPACK FOOTER //
// ./src/scripts/components/MainNav/NewAgentStatus/index.js